import CategoryReportPage from "./CategoryReportPage";
import DocumentFile from "../../models/Document";
import CategoryWrapper from "../../core/components/CategoryWrapper";

export default function ReportPage(props: any) {
  return <CategoryWrapper MainModel={DocumentFile} BoxContent={CategoryReportPage} />;
}
